import React from "react";

function DentalChart() {
  return <div>Coming soon</div>;
}

export default DentalChart;
